import React from 'react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import addressIcon from './../map-location.svg';
import { Item, Button, Label, Icon } from 'semantic-ui-react';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

class AddressItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddingAddress: false,
        };

        this.showAddAddress = this.showAddAddress.bind(this);
        // this.addParent = this.addParent.bind(this);
    }

    showAddAddress() {
        this.setState({isAddingAddress: true});
    }

    render() {
        const {isAddingAddress} = this.state;
        const {addresses} = this.props;
        return (
            <Item>
                <Item.Image src={addressIcon} size='tiny'/>
                <Item.Content style={{paddingRight: '21px'}}>
                    <Item.Header><AddAddress showAddAddress={this.showAddAddress}/></Item.Header>
                    <Item.Description>
                        {isAddingAddress &&
                            {/* <Segment raised>
                                <Form>
                                    <Form.Field>
                                        <label><FormattedMessage id='orgUnitDetailed.contactValue'/></label>
                                        <Input name='value' value={this.state.value} onChange={this.handleChange} />
                                    </Form.Field>

                                    <Form.Field>
                                        <label><FormattedMessage id='orgUnitDetailed.contactType'/></label>
                                        <Dropdown clearable
                                            onChange={(e, {value}) => this.setState({ contactType: {
                                                                                            id: value
                                                                                        } })}
                                            fluid
                                            selection
                                            value={this.state.contactType.id}
                                            options={this.state.contactTypes.map(contactType =>
                                                ({ key: contactType.id, value: contactType.id, text: contactType.name })
                                            )}/>
                                    </Form.Field>

                                    <Form.Field>
                                        <label><FormattedMessage id='orgUnitDetailed.contactDescription'/></label>
                                        <Input name='description' value={this.state.description} onChange={this.handleChange} />
                                    </Form.Field>

                                    <Button type='submit'>Submit</Button>
                                </Form>
                            </Segment> */}
                        }
                        <div className="ui bulleted list">
                            {addresses.map((address, index) =>
                                <div className="item" key={index}>{address.street}, {address.placePlaceName}</div>
                            )}
                        </div>
                    </Item.Description>
                </Item.Content>
            </Item>
        )
    }
}

const AddAddress = props => (
    <Button as='div' labelPosition='left' onClick={(event, data) => {props.showAddAddress()}}>
        <Label as='a' basic pointing='right'><FormattedMessage id='orgUnitDetailed.addresses'/></Label>
        <Button icon>
            <Icon name='plus' />
        </Button>
    </Button>
)

class AddAddress1 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            street: '',
            place: {
                id: null,
                contactTypeName: ''
            },
            description: '',
            contactTypes: [],
            isOpen: false
        }
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        axios.get('/contact-types')
        .then(response => {
            this.setState({ contactTypes: response.data });
        }).catch(error => {
            // TODO emir: use toast?
            console.error('Failed to fetch contact types');
        });
    }

    close = () => this.setState({ isOpen: false })

    submit() {
        // TODO emir: add validation
        const orgUnitContact = {
            value: this.state.value,
            description: this.state.description,
            contactType: this.state.contactType
        }
        const {orgUnitId} = this.props;

        axios.post(`/organizational-units/${orgUnitId}/contacts`, orgUnitContact)
        .then(response => {
            this.close();
        }).catch(error => {
            alert(error);
        })
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    render() {
        return (
        <span>
            <Button as='div' labelPosition='left' onClick={(event, data) => {this.setState({ isOpen: true })}}>
                <Label as='a' basic pointing='right'><FormattedMessage id='orgUnitDetailed.addresses'/></Label>
                <Button icon>
                    <Icon name='plus' />
                </Button>
            </Button>

        {/* <Modal
            size='fullscreen'
            open={this.state.isOpen}
            onClose={this.close}
            >
            <Modal.Header><FormattedMessage id='orgUnitDetailed.addContacts'/></Modal.Header>
            <Modal.Content image scrolling>
                <Image wrapped size='small' src={contactIcon} />
                <Modal.Description>
                    <Form>
                        <Form.Field>
                            <label><FormattedMessage id='orgUnitDetailed.contactValue'/></label>
                            <Input name='value' value={this.state.value} onChange={this.handleChange} />
                        </Form.Field>

                        <Form.Field>
                            <label><FormattedMessage id='orgUnitDetailed.contactType'/></label>
                            <Dropdown clearable
                                onChange={(e, {value}) => this.setState({ contactType: {
                                                                                id: value
                                                                            } })}
                                fluid
                                selection
                                value={this.state.contactType.id}
                                options={this.state.contactTypes.map(contactType =>
                                    ({ key: contactType.id, value: contactType.id, text: contactType.name })
                                )}/>
                        </Form.Field>

                        <Form.Field>
                            <label><FormattedMessage id='orgUnitDetailed.contactDescription'/></label>
                            <Input name='description' value={this.state.description} onChange={this.handleChange} />
                        </Form.Field>

                        <Button type='submit'>Submit</Button>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button color='red' onClick={this.close}>
                    <Icon name='remove' /> <FormattedMessage id='common.cancel'/>
                </Button>
                <Button color='green' onClick={this.submit}>
                    <Icon name='checkmark' /> <FormattedMessage id='common.ok'/>
                </Button>
            </Modal.Actions>
        </Modal> */}
        </span>
        )
    }
}

export default AddressItem;



// WEBPACK FOOTER //
// ./src/views/OrganizationalUnit/components/OrgUnitAddress.js